var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-lg-4 wow fadeInUp"},[_c('content-loader',{staticStyle:{"margin-top":"30px"},attrs:{"width":"600","height":"200","preserveAspectRatio":"none"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }